import request from './request';
/**
 * 查询角色
 */
export function searchRole(params) {
    return request('/role/list', {
        method: 'POST',
        params,
    });
}

/**
 * 获取角色详情
 */
export function getRoleDetail(params) {
    return request(`/role/${params.id}`, {
        method: 'GET',
        params,
    });
}

/**
 * 新建角色
 */
export function addRole(params) {
    return request('/role', {
        method: 'POST',
        params,
    });
}

/**
 * 编辑角色
 */
export function editRole(params) {
    return request('/role', {
        method: 'PATCH',
        params,
    });
}

/**
 * 删除角色
 */
export function deleteRole(params) {
    return request(`/role/${params.id}`, {
        method: 'DELETE',
        params,
    });
}

/**
 * 查询角色用户列表
 */
export function getRoleUserList(params) {
    return request('/role/user', {
        method: 'GET',
        params,
    });
}

/**
* 查询角色的操作记录
*/
export function getRoleRecord(id, params) {
    return request(`role/record/${id}`, {
        method: 'GET',
        params,
    });
}
